module.exports = __webpack_public_path__ + "static/img/side-modal.9b40cda.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/side-modal.gif
// module id = tGZj
// module chunks = 0